module.exports = __webpack_public_path__ + "static/media/health.afbb60d7.jpg";